import { useTranslation } from "react-i18next";

import { productionFacilityName } from "utils/constants/storage";

import "./ProductionFacilitySelector.scss";

export default function ProductionFacilitySelector() {
  const { t } = useTranslation();
  const productionFacility = sessionStorage.getItem(productionFacilityName) || "finsensvej";

  function handleChangeClick() {
    console.log("Change production facility clicked");
    if (productionFacility === "finsensvej") {
      sessionStorage.setItem(productionFacilityName, "solrød");
    } else {
      sessionStorage.setItem(productionFacilityName, "finsensvej");
    }

    window.location.reload();
  }

  return (
    <div className="production-facility-selector">
      <p className="selector-title">{t("production:ProductionFacility")}:</p>
      <p className="selected-option">
        {t(`production:${productionFacility}`)}
        <span onClick={handleChangeClick}>{t("production:Change")}</span>
      </p>
    </div>
  );
}
